import Pricing from './pricingTypes';

export default {
	...Pricing
};



// WEBPACK FOOTER //
// ./src/constants/gcp/index.js